module.exports = __webpack_public_path__ + "static/media/job116.6ddaee76.ico";